export default "__VITE_ASSET__DaDGtQL1__"